import { render, staticRenderFns } from "./ProductDefault.vue?vue&type=template&id=c5d81280&scoped=true&"
import script from "./ProductDefault.vue?vue&type=script&lang=js&"
export * from "./ProductDefault.vue?vue&type=script&lang=js&"
import style0 from "./ProductDefault.vue?vue&type=style&index=0&id=c5d81280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d81280",
  null
  
)

export default component.exports